import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";

export const PollsModule = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;

export const PollList = styled.div`
	margin-top: 1.5rem;
	display: flex;
	flex-direction: column;
	color: ${colours.black};
`;
